import { useFeatureLoyaltyShortCodePaymentErrorModalQuery } from 'generated/sanity-graphql';
import { FEATURE_LOYALTY_UI_SINGLETON } from 'hooks/use-feature-loyalty-ui/use-feature-loyalty-ui';

export const useShortCodePaymentErrorModal = () => {
  const { data, loading } = useFeatureLoyaltyShortCodePaymentErrorModalQuery({
    variables: { featureLoyaltyUIId: FEATURE_LOYALTY_UI_SINGLETON },
  });

  return { data: data?.LoyaltyUI, loading };
};
